<div class="documents-container">
  
  <app-cosign-search
  (signClicked)="onClickSign()"
  (searchClicked)="onSearch($any($event))"
  [isEnable] = "enableSign"
></app-cosign-search>
  <div class="mt-5">
      <thera-client-side-list
        [rowData]="rowData"
        (rowChecked)="onRowChecked($event)"
        [columnDefs]="columnDefs"
        [hideGridLines]="true"   
        [enablePagination]="true" 
        [rowSelection] = "rowSelection"
        [suppressRowClickSelection]="true"
      ></thera-client-side-list>
 </div>
</div>
